import { AxiosRequestConfig, AxiosResponse } from "axios";
import { initSession } from "./apiServices";
import { getGsid, setGSIDCookie } from "../utils/utils";
import { isExemptPath } from "../utils/exemptPaths";
import { fetchCsrfToken } from "./csurfService";

let sessionInitialized = false;
let sessionPromise:any = null;

export const ensureSession = () => {
  if (sessionInitialized) return;
  if (!sessionPromise){
    sessionPromise = initSession().then(() => {
      sessionInitialized = true;
    }).catch((err:any) => {
      console.log("Failed to initialize session",err);
    }).finally(() => {
      sessionPromise = null;
    });
  }
  return sessionPromise
}

export const addGSIDToHeader = (config: AxiosRequestConfig) => {
    const method = config.method?.toUpperCase();
        const g = getGsid();
        if (g !== undefined && g !== ""){
          config.headers["GSID"] = g;
        }
    return method;
}

export const interceptorRequestBody = async (config: AxiosRequestConfig) => {
    if (config.url  !== '/session/init'){
        await ensureSession();
    }
    const method = addGSIDToHeader(config);
        if (
        ["POST", "PUT", "PATCH", "DELETE"].includes(method as string) &&
        !isExemptPath(config.url as string)
        ) {
        const csrfToken = await fetchCsrfToken();
        config.headers["X-CSRF-Token"] = csrfToken;
        }
    return config
}

export const interceptorResponseBody = (response:AxiosResponse<any>) => {
    if (response.headers["gsid"] !== undefined){
      setGSIDCookie(response.headers["gsid"]);
    }
    return response
}
export const interceptorResponseBodyError = (error:any) => {
    if (error.response) {
      error = {
        status: error.response.status, 
        message: error.response.data?.message ?? error.response.data, 
        ...error
      };
      console.error("Error response:", error);
    } else {
      console.error("Error message:", error.message);
      if (error?.config?.url === '/log/event'){
        return Promise.resolve({error: "Connect error to event api"});
      }
    }
    return Promise.reject(error);
}